import React from "react";
import { ScoreCardPropTypes } from "../../../features/compensation/types";
import MessageInfo from "../../messageInfo/MessageInfo";
import { useGetScorecardRulesStatusQuery } from "./statusDetailSlice";

const StatusDetail = ({ inputYear, inputMonth, inputScorecardVersion }: ScoreCardPropTypes) => {
    const { data: scorecardRulesStatusDetail } = useGetScorecardRulesStatusQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
        },
        { skip: !inputScorecardVersion || !inputMonth || !inputScorecardVersion }
    );

    if (scorecardRulesStatusDetail?.data?.length > 0) {
        return (
                <div className="card my-4 borderRadius10">
                    <div className="card-body">
                        <h6 className="card-title">Status</h6>
                        <hr className="mt-2" />
                        <div className="row mt-3">
                            <div className="col-md-9">Month-end Associates and Team Leads</div>
                            <div className="col-md-3">
                                <span>{scorecardRulesStatusDetail?.data[0]?.month_end_associates_and_team_leads}</span>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-md-9">Associate Payout</div>
                            <div className="col-md-3">
                                {scorecardRulesStatusDetail?.data[0]?.associate_payout}
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-9">Team Lead Payout</div>
                            <div className="col-md-3">
                                {scorecardRulesStatusDetail?.data[0]?.team_lead_payout}
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-9">Total Payout</div>
                            <div className="col-md-3">
                                {scorecardRulesStatusDetail?.data[0]?.total_payout}
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
    return (
        <div className="row">
            <div className="col-12">
            <h6 className="card-title">Status</h6>
            <hr className="mt-2" />
            <MessageInfo
                title="No results found."
                message="Try adjusting the month or scorecard filter above."
                rowHeight="308px"
            />
        </div>
        </div>
        )
}

export default StatusDetail;